export default __webpack_public_path__ + "static/media/img_download_webapp.031f4271.svg";